import { useMemo } from 'react';

import { MedicalInformationCountByType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { createInterpolatedTranslationKey, useTranslate } from '@dreryk/react-common';
import {
   appendTestableElementAttributes,
   Badge,
   BadgeType,
   ChevronRightIcon,
   IconSize,
   IconWrapper,
   SidePanelListItem,
   SidePanelListItemHeaderVariant,
   StyledFlex,
} from '@dreryk/react-components';

import { medicalDataTranslationKeys } from '../../translations';
import { HistoricalVisitsListItemHeader } from '../historicalVisits/HistoricalVisitsListItemHeader';

export const useCreateMedicalDataListItems = (
   medicalData: MedicalInformationCountByType[] | undefined,
   onItemHeaderClick: (item: MedicalInformationCountByType | undefined) => void
): SidePanelListItem[] | undefined => {
   const translate = useTranslate();
   return useMemo(() => {
      if (!medicalData) {
         return undefined;
      }
      return medicalData.map((medicalDataItem) => {
         return {
            id: medicalDataItem.type,
            headerVariant: SidePanelListItemHeaderVariant.PRIMARY,
            headerContent: (
               <HistoricalVisitsListItemHeader
                  text={createInterpolatedTranslationKey(medicalDataTranslationKeys.listItemName, {
                     name: translate(medicalDataTranslationKeys.categories[medicalDataItem.type]),
                     count: medicalDataItem.medicalInformationCount,
                  })}
                  {...appendTestableElementAttributes(`preview-${medicalDataItem.type}`)}
                  icon={
                     <StyledFlex direction={'row'} gap={'4px'} alignItems={'center'}>
                        <Badge
                           testId={'unsignedAttachmentCount'}
                           type={BadgeType.NEGATIVE}
                           count={medicalDataItem.unsignedAttachmentCount}
                           visible={Boolean(medicalDataItem.unsignedAttachmentCount)}
                        />

                        <IconWrapper testId={'expand'} size={IconSize.SMALL}>
                           <ChevronRightIcon />
                        </IconWrapper>
                     </StyledFlex>
                  }
               />
            ),
            onClick: () => onItemHeaderClick(medicalDataItem),
         };
      });
   }, [medicalData, onItemHeaderClick, translate]);
};
